// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.root__O9c2n17R85{display:flex;flex:0 0 var(--dixa-size-spacer-200);height:auto}`, "",{"version":3,"sources":["webpack://./src/components/conversation/conversationStatusColorBox/conversationStatusColorBox.module.scss"],"names":[],"mappings":"AAAA,kBACE,YAAA,CACA,oCAAA,CACA,WAAA","sourcesContent":[".root {\n  display: flex;\n  flex: 0 0 var(--dixa-size-spacer-200);\n  height: auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `root__O9c2n17R85`
};
export default ___CSS_LOADER_EXPORT___;
